export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["खोज"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["कौन से कॉलम प्रदर्शित करने हैं यह चुनने के लिए क्लिक करें"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रदर्शित कॉलम"])}
}